import { render, staticRenderFns } from "./ReleaseDate.vue?vue&type=template&id=d58ffc72&scoped=true&"
import script from "./ReleaseDate.vue?vue&type=script&lang=js&"
export * from "./ReleaseDate.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDate.vue?vue&type=style&index=0&id=d58ffc72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58ffc72",
  null
  
)

export default component.exports